import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
export const getScopesAsMap = createSelector(getScopes, scopes => scopes.reduce((result, item) => {
  result[item] = item;
  return result;
}, {}));